/**
 * Builds a 12-month availability window starting at `offsetMonths` from today.
 * @param offsetMonths - Number of months to shift the start from today (default 0)
 * @param horizonMonths - Window length in months (default 12)
 *
 * Normalises to the 1st of the current UTC month before shifting so that
 * setMonth() never overflows on end-of-month dates (e.g. May 31 + 6 →
 * December 1 instead of the expected November 1).
 */
export function buildAvailabilityWindow(
  offsetMonths = 0,
  horizonMonths = 12,
): { from: string; to: string } {
  const now = new Date();
  // Normalise to the 1st of the current UTC month before shifting.
  // Without this, month-end dates (e.g. May 31) overflow into the next month when
  // the target month has fewer days (May 31 + 6 months → Nov 31 → Dec 1).
  const fromUTC = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + offsetMonths, 1));
  const toUTC = new Date(
    Date.UTC(fromUTC.getUTCFullYear(), fromUTC.getUTCMonth() + horizonMonths, 1),
  );
  return {
    from: fromUTC.toISOString().slice(0, 10),
    to: toUTC.toISOString().slice(0, 10),
  };
}
